module.exports = __webpack_public_path__ + "img/schedule_sp.23715e85.svg";